// FAQ accordion for NCP page
(function () {
  document.querySelectorAll('.ncp-faq-item').forEach(function (item) {
    var btn = item.querySelector('.ncp-faq-q');
    var toggle = item.querySelector('.ncp-faq-toggle');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(isOpen));
      if (toggle) toggle.textContent = isOpen ? '\u2212' : '+';
    });
  }); 
})();
